const actions = {
	BILLING_PAYMENT_METHOD_INIT: 'BILLING_PAYMENT_METHOD_INIT',
	init: () => ({
		type: actions.BILLING_PAYMENT_METHOD_INIT,
	}),
};

export default actions;
